import { Button, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { MdAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import useDataFetching from 'hooks/useDataFetching';
import { config } from 'variables/config';
import AddUser from './AddUser';
import UpdateUserInformations from './UpdateUserInformations';
import { useAuthUser } from 'react-auth-kit';
import { CHECK_PERMISSIONS } from 'Constaints';
import { capitalize, Chip } from '@mui/material';
import MButton from 'components/Mbutton';
import MuiTable from 'components/MuiTable';
import { ACCOUNT_HEADER } from 'Constaints';
import usePostAxiosData from 'hooks/usePostAxiosData';
import { useTranslation } from 'react-i18next';

const AdminComptes = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation('admin_comptes');

  const [isOpenUM, setIsOpenUM] = useState(false);
  const [, setCloseUM] = useState(false);

  const [, , roles] = useDataFetching(`${config.app.api_url}/roles`);
  const [role, setRole] = useState();
  // console.log("roles", role)

  const auth = useAuthUser();
  const [, , usr] = useDataFetching(`${config.app.api_url}/users/${auth()?.user?.id}`);

  const [loadingU, errorU, users, fetchDataU] = useDataFetching(
    `${config.app.api_url}/roles/${role || (roles?.data?.length > 0 && roles?.data[0]?.id)}/users`
  );

  const [userId, setUserId] = useState(null);
  const [, enableAccount, , , result] = usePostAxiosData(
    `users/${userId?.id}/enable-account`,
    'POST'
  );
  const [, disableAccount, , , resultD] = usePostAxiosData(
    `users/${userId?.id}/disable-account`,
    'POST'
  );

  useEffect(() => {
    fetchDataU();
  }, [result, resultD, fetchDataU]); // Ajouter fetchDataU aux dépendances

  const handleAccount = ({ isEnable, user }) => {
    if (isEnable === true) {
      window.confirm(t('activate_user_confirmation')) &&
        enableAccount({}, `users/${user?.id}/enable-account`); // Traduit
    } else {
      window.confirm(t('deactivate_user_confirmation')) &&
        disableAccount({}, `users/${user?.id}/disable-account`); // Traduit
    }
  };

  function createData(N, FirstName, LastName, Email, Phone, Enable, Options) {
    return {
      N,
      FirstName,
      LastName,
      Email,
      Phone,
      Enable,
      Options,
    };
  }

  const handleClick = (user) => {
    setIsOpenUM(true);
    setUserId(user?.id);
  };

  const rows = users?.data?.map((item, index) => {
    return {
      handleClick: (e) => handleClick(item),
      datas: createData(
        index + 1,
        item.firstName,
        item?.lastName,
        item?.mail,
        item?.phone,
        item?.enable ? (
          <Chip
            color="success"
            variant="outlined"
            className="capitalize-none"
            label={capitalize(t('status_active'))} // Traduit
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleAccount({ isEnable: false, user: item });
            }}
          />
        ) : (
          <Chip
            color="error"
            className="capitalize-none"
            label={capitalize(t('status_inactive'))} // Traduit
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleAccount({ isEnable: true, user: item });
            }}
          />
        ),
        <MButton variant={'white'} style={{ borderRadius: 20 }} onClick={() => handleClick(item)}>
          {t('edit_button')} {/* Traduit */}
        </MButton>
      ),
    };
  });

  return (
    <div>
      {/* {loadingU && <PreloaderSpinner />} */}
      <div className="mt-2 grid h-full grid-cols-1 gap-5">
        <div className="mt-5 flex items-center justify-between">
          <div>
            <select
              onChange={(e) => setRole(e.target.value)}
              className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
              name="region"
              id="region"
            >
              {roles?.data?.length > 0 &&
                roles?.data.map((item) => {
                  return (
                    <option
                      key={item?.id} // Ajout de la clé unique
                      selected={
                        (role === undefined || role === null) &&
                        roles?.data?.length > 0 &&
                        roles?.data[0]?.id === item?.id
                      }
                      value={item?.id}
                    >
                      {item?.name}
                    </option>
                  );
                })}
            </select>
          </div>
          <div>
            {usr?.data?.roles.length > 0 &&
              usr?.data?.roles?.map((role) => {
                return (
                  CHECK_PERMISSIONS(role?.permissions, 'Ajouter un compte') && (
                    <Button onClick={() => onOpen()} colorScheme="blue">
                      <MdAdd className="h-6 w-6" />
                      {t('add_account_button')}
                    </Button>
                  )
                );
              })}
          </div>
        </div>

        <MuiTable
          loading={loadingU}
          hidePagiation={true}
          columns={ACCOUNT_HEADER(t)}
          rows={rows}
          textEmpty={t('no_work_permit')} // Traduit
        />
      </div>

      {/* Modal création d'un user */}
      <AddUser isOpen={isOpen} onClose={onClose} />

      {/* Modification des informations du user */}
      {userId && (
        <UpdateUserInformations
          fetchData={fetchDataU}
          isOpen={isOpenUM}
          setIsOpen={setIsOpenUM}
          onClose={() => setUserId(null)}
          userId={userId}
        />
      )}
    </div>
  );
};

export default AdminComptes;
